var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tooltip',{attrs:{"placement":"bottom","title":_vm.$t('clickToCopy')}},[_c('Tag',{staticClass:"m-0",on:{"click":_vm.copy}},[_vm._v(" "+_vm._s(_vm.apiKey)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }